import join from './join';
import angel from './angel'
import WisdomSpace from './wisdom-space'
import location from './location'
import projectAgent from './project-agent'
import config from '@config';

const Home = () => import(`../../views/home/index.vue`);

const home = {
  path: '/',
  name: 'home',
  //回到旧项目的办公室
  redirect() {
    location.href = `${config.path.base}`;
  },
  component: Home,
  children: [
    join,
    angel,
    WisdomSpace,
    location,
    projectAgent,
  ]
};

export default home;